import React from "react";
import styles from "./ThButton.module.css";

const ThButton = ({
  children,
  onClick,
  type = "button",
  className = "",
  inactive = false,
  isText = false,
  color,
  textColor,
  style = {},
  ...props
}) => {
  // Merge custom color styles with any passed `style`
  const customStyle = {
    ...style, // user's own styles first
    ...(color && !inactive && !isText && { background: color }),
    ...(textColor && !inactive && !isText && { color: textColor }),
  };

  return (
    <button
      type={type}
      onClick={!inactive ? onClick : undefined}
      className={`
        ${styles.thButton} 
        ${inactive ? styles.inactive : ""} 
        ${isText ? styles.textButton : ""} 
        ${className}
      `}
      style={customStyle}
      {...props}
    >
      {children}
    </button>
  );
};

export default ThButton;
